export const ptvData = [
  { ptv: 1.8, r50p: 5.9, r50v: 7.5, d2cmp: 50.0, d2cmv: 57.0 },
  { ptv: 3.8, r50p: 5.5, r50v: 6.5, d2cmp: 50.0, d2cmv: 57.0 },
  { ptv: 7.4, r50p: 5.1, r50v: 6.0, d2cmp: 50.0, d2cmv: 58.0 },
  { ptv: 13.2, r50p: 4.7, r50v: 5.8, d2cmp: 50.0, d2cmv: 58.0 },
  { ptv: 22.0, r50p: 4.5, r50v: 5.5, d2cmp: 54.0, d2cmv: 63.0 },
  { ptv: 34.0, r50p: 4.3, r50v: 5.3, d2cmp: 58.0, d2cmv: 68.0 },
  { ptv: 50.0, r50p: 4.0, r50v: 5.0, d2cmp: 62.0, d2cmv: 77.0 },
  { ptv: 70.0, r50p: 3.5, r50v: 4.8, d2cmp: 66.0, d2cmv: 86.0 },
  { ptv: 95.0, r50p: 3.3, r50v: 4.4, d2cmp: 70.0, d2cmv: 89.0 },
  { ptv: 126.0, r50p: 3.1, r50v: 4.0, d2cmp: 73.0, d2cmv: 91.0 },
  { ptv: 163.0, r50p: 2.9, r50v: 3.7, d2cmp: 77.0, d2cmv: 94.0 },
];
